import { getState } from 'src/store';

export const getRoomID = (): string | null => {
    const { user } = getState();
    return `${user?.userType}${user?.userID}`;
};
